import axios from "axios";

import env from "src/config/env";
import type { RequestBody } from ".";
import type { ApiPayload } from "src/types/api";
import type { AuthUser } from "src/types/auth";
import { onResFulfilled, onResRejected } from "./helpers";

/**
 * Auth calls go through their own instance: it carries no Authorization header, and its
 * error handler must not run the 401 "session expired" reload — a failed login is a 401.
 */
export const authApi = axios.create({
	baseURL: env.REACT_APP_API_BASE_URL,
	headers: { "Content-Type": "application/json" },
});

authApi.interceptors.response.use(onResFulfilled, onResRejected);

const post = <T = unknown>(url: string, data?: unknown) => authApi.post(url, data) as unknown as Promise<ApiPayload<T>>;

export interface LoginPayload {
	email: string;
	password: string;
}

export interface LoginResult {
	user?: AuthUser;
	access_token?: string;
}

export const loginFn = (data: LoginPayload) => post<LoginResult>("/auth/login", data);

export const register = (data: { email: string } & RequestBody) => post<LoginResult>("/auth/register", data);

export const forgotPassword = (data: { email: string }) => post("/auth/forgot-password", data);

export const resetPassword = (data: RequestBody) => post("/auth/reset-password", data);

export const verifyOtp = (data: RequestBody) => post<LoginResult>("/auth/verify_otp", data);

export const sendOtp = (data: RequestBody) => post("/auth/send-otp", data);
